import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "context";
import { QueryKeys } from "queryClient";
import { getAllExpansionListShortened } from "modules/expansions/api";
import { useExpansionListFilterAndSortShortened } from "../useExpansionListFilterAndSortShortened";

export const useExpansionListShortened = (filter = true) => {
  const filterAndSortExpansions =
    useExpansionListFilterAndSortShortened(filter);

  const { isAuth, isLoading: isAuthLoading } = useAuthContext();

  const { data, isLoading } = useQuery({
    queryKey: [QueryKeys.ExpansionsShortened],
    queryFn: async () => {
      console.log("Called useExpansionListShortened");
      const expansionList = await getAllExpansionListShortened(isAuth);

      console.log("Called useExpansionListShortened", expansionList);

      return expansionList;
    },
    staleTime: 1000 * 60 * 15, // 15 minutes
    gcTime: 1000 * 60 * 60, // 1 hour
    enabled: !isAuthLoading,
  });

  const expansionList = useMemo(
    () => filterAndSortExpansions(data ?? []),
    [data, filterAndSortExpansions],
  );

  return {
    expansionList,
    isLoading,
  };
};
